export default function checkAllAgreements() {
    const checkAllBox = document.getElementById('checkAllAgreements');
    if (!checkAllBox) return;

    checkAllBox.addEventListener('change', function () {
        const form = this.closest('form');
        if (!form) return;
        const checkboxes = form.querySelectorAll(
            'input[type="checkbox"]:not(#checkAllAgreements)'
        );
        checkboxes.forEach(checkbox => {
            checkbox.checked = this.checked;
        });
    });
}
